<template>
<div class="footer">
        <footer>
          <div class="container">
            <div class="foot-logo"></div>
            <div class="foot-about">
              <p><span>&#169; </span>2021 Kathryn Ross-Nash All Rights Reserved.</p>
              <a href="" v-on:click.prevent="showTc">Privacy Policy</a>
            </div>
            <a href="https://oneit.rs/" target="_blank">OneIT</a>
            
          </div>
        </footer>
        <section class="side-menu" :class="{open: menuOpen}">
          <a href="" class="close" v-on:click.prevent="$emit('update:menuOpen', false)"></a>
          <ul class="mob-only">
<li v-for="(menuItem, mi) in menuItems" class="menu-item" :class="{open: currentOpen==mi, active: menuItem.active}" v-if="!menuItem.loggedIn || loggedIn">
  <a :href="resolvedLink(menuItem.link)" v-on:click.prevent="clickItem(menuItem, mi)" :class="{active: menuItem.active}">
    {{ menuItem.title }}
  </a>
  <ul v-if="menuItem.sub && menuItem.sub.length">
    <li v-for="(menuItem2, m2i) in menuItem.sub">
      <a :href="resolvedLink(menuItem2.link)" v-on:click.prevent="clickItem(menuItem2)" :class="{active: menuItem2.active}">
        {{ menuItem2.title }}
      </a>
      <ul v-if="menuItem2.sub && menuItem2.sub.length">
        <li v-for="(menuItem3, m3i) in menuItem2.sub">
          <a :href="resolvedLink(menuItem3.link)" v-on:click.prevent="clickItem(menuItem3)" :class="{active: menuItem3.active}">
            {{ menuItem3.title }}
          </a>
        </li>
      </ul>
    </li>
  </ul>
</li>
          </ul>
          <ul>
<li v-for="(menuItem, mi) in menuItems2" class="menu-item" :class="{open: currentOpen==mi, active: menuItem.active}" v-if="!menuItem.loggedIn || loggedIn">
  <a :href="resolvedLink(menuItem.link)" v-on:click.prevent="clickItem(menuItem, mi)" :class="{active: menuItem.active}">
    {{ menuItem.title }}
  </a>
  <ul v-if="menuItem.sub && menuItem.sub.length">
    <li v-for="(menuItem2, m2i) in menuItem.sub">
      <a :href="resolvedLink(menuItem2.link)" v-on:click.prevent="clickItem(menuItem2)" :class="{active: menuItem2.active}">
        {{ menuItem2.title }}
      </a>
    </li>
  </ul>
</li>
          </ul>
        </section>
</div>
</template>

<script>
import mainNav from './mainNav';
export default {
  mixins: [mainNav],
  data: ()=>({
    menuItems2: [
      {link: "https://www.kathirossnash.com/", title: "Kathryn Ross Nash"},
      {link: "https://www.kathirossnash.com/about", title: "About", sub: [
        {link: "https://www.kathirossnash.com/bio", title: "Bio"},
        {link: "https://www.kathirossnash.com/redthreadranch", title: "The Red Thread Ranch"},
        {link: "https://www.kathirossnash.com/testimonials", title: "Testimonials"},
        {link: "https://www.kathirossnash.com/bookphotoshoot", title: "The Red Thread Books in the Making"},
      ]},
      {link: "https://www.kathirossnash.com/education", title: "Education", sub: [
        {link: "https://www.kathirossnash.com/trainings", title: "Pilates Advanced Professional Teacher Training"},
        {link: "https://www.kathirossnash.com/workshops-trainings", title: "Online Workshops & Workouts"},
        {link: "https://www.kathirossnash.com/workshops", title: "Workshops"},
      ]},
      {link: "https://www.kathirossnash.com/shop", title: "Shop", sub: [
        {link: "https://www.kathirossnash.com/the-red-thread-the-mat", title: "TRT: The Mat"},
        {link: "https://www.kathirossnash.com/the-red-thread-the-armbaby-chair", title: "TRT: The Arm/Baby Chair"},
        {link: "https://www.kathirossnash.com/the-red-thread-the-electrichigh-chair", title: "TRT: The High/Electric Chair"},
        {link: "https://www.kathirossnash.com/trt-the-foundational-reformer", title: "TRT: The  Foundational Reformer"},
      ]},
//       {link: "https://www.kathirossnash.com/teacher-training-alumni-directory", title: "Alumni", sub: [
//         {link: "https://www.kathirossnash.com/teacher-training-alumni", title: "2015"},
//         {link: "https://www.kathirossnash.com/20152016", title: "2016"},
//         {link: "https://www.kathirossnash.com/20162017", title: "2017"},
//         {link: "https://www.kathirossnash.com/2017", title: "2017"},
//         {link: "https://www.kathirossnash.com/currently-training", title: "2018"},
//         {link: "https://www.kathirossnash.com/2019", title: "2019"},
//       ]},
      {link: "https://www.kathirossnash.com/contact", title: "Contact"},
    ],
    currentOpen: null,
  }),
  props: ["menuOpen"],
  computed: {
    loggedIn() {
      return appRoot.loggedIn;
    }
  },
  methods: {
    clickItem(item, mi) {
      if (mi!=undefined && item.sub && this.currentOpen!=mi)
        return this.currentOpen=mi;
      if (typeof(item.link)=="string")
        window.open(item.link, "_self");
      if (item.action) {
        this.$emit('action', {name: item.action, args: item.args});
      } else if (item.link) {
        if (typeof(item.link)=="string" && item.link.indexOf("http")==0)
          window.open(item.link, "_self");
        else {
          this.$router.push(item.link);
          this.$emit("update:menuOpen", false);
        }
      }
    },
    resolvedLink(link) {
      if (typeof(link)=="string")
        return link;
      return this.$router.resolve(link).href;
    },
    showTc() {
      appRoot.tcVisible=true;
    },
  },
}
</script>
